import React, { useState } from 'react';

const methods = [
  { title: 'Email', value: 'dixitk941@gmail.com', link: 'mailto:dixitk941@gmail.com' },
  { title: 'LinkedIn', value: 'linkedin.com/in/karan-dixit21', link: 'https://www.linkedin.com/in/karan-dixit21' },
  { title: 'GitHub', value: 'github.com/dixitk941', link: 'https://github.com/dixitk941' },
];

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          access_key: '4a23f842-0992-4aa8-8b4c-5c89ed67160b',
          ...formData,
        }),
      });
      const data = await response.json();
      if (data.success) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="section border-b border-[var(--line)]">
      <div className="wrap grid grid-cols-1 lg:grid-cols-2 gap-14">
        <div>
          <p className="t-kicker mb-4">Contact</p>
          <h2 className="t-display text-5xl md:text-7xl mb-6">
            Let’s make<br />
            <em className="italic text-[var(--signal)]">something live.</em>
          </h2>
          <p className="t-body mb-10 max-w-md">
            A question, a product idea, or a hello — I’m open for freelance work.
          </p>
          <div className="space-y-0">
            {methods.map((method) => (
              <a
                key={method.title}
                href={method.link}
                target="_blank"
                rel="noopener noreferrer"
                className="py-5 border-b border-[var(--line)] flex items-center justify-between gap-4 no-underline"
              >
                <div>
                  <p className="t-kicker mb-1">{method.title}</p>
                  <p className="text-[var(--ink)] break-all">{method.value}</p>
                </div>
                <span className="text-[var(--signal)]">→</span>
              </a>
            ))}
          </div>
        </div>

        <form onSubmit={handleSubmit} className="rounded-3xl border border-[var(--line)] bg-[var(--bg-2)] p-6 md:p-8">
          <input className="field" type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Name" />
          <input className="field" type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Email" />
          <input className="field" type="text" name="subject" value={formData.subject} onChange={handleChange} required placeholder="Subject" />
          <textarea className="field resize-none" name="message" value={formData.message} onChange={handleChange} required rows="5" placeholder="Message" />
          <button type="submit" disabled={isSubmitting} className="btn-signal mt-8 disabled:opacity-50">
            {isSubmitting ? 'Sending…' : 'Send message'}
          </button>
          {submitStatus === 'success' && <p className="text-[var(--ink)] pt-4">Message sent. I’ll get back to you soon.</p>}
          {submitStatus === 'error' && <p className="t-muted pt-4">Something went wrong. Email me directly.</p>}
        </form>
      </div>
    </section>
  );
};

export default Contact;
